import { useQuery } from '@tanstack/react-query';

import { storesApi } from '../api/stores.js';
import { useAuth } from '../auth/AuthProvider.jsx';

/**
 * The set of stores the current user may assign a record to.
 *
 * Admins (with `stores:read`) get the full store list from the API. Scoped
 * staff such as sellers do not hold `stores:read`, so calling the admin stores
 * endpoint would 403; for them we fall back to the assigned stores already
 * carried in the session (`storeSelection.stores`). Both shapes expose
 * `{ _id, name, code }`, so consumers can treat them uniformly.
 */
export function useStoreOptions({ enabled = true } = {}) {
  const { hasPermission, storeSelection } = useAuth();
  const canList = hasPermission('stores:read');

  const query = useQuery({
    queryKey: ['stores', 'all'],
    enabled: enabled && canList,
    queryFn: () => storesApi.list({ limit: 100 })
  });

  if (canList) {
    return { stores: (query.data && query.data.items) || [], isLoading: query.isLoading };
  }

  return { stores: (storeSelection && storeSelection.stores) || [], isLoading: false };
}
